import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IBlogResponse, IPostTag, IPostTagsResponse } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { BlogService } from 'src/app/services/blog.service';
import {Location} from '@angular/common';
import { SnackbarService } from 'src/app/services/snackbar.service';
declare var $: any;
import { base64StringToBlob } from 'blob-util';
import { ImageUploadComponent } from '../shared-components/image-upload/image-upload.component';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-create-blog',
  templateUrl: './create-blog.component.html',
  styleUrls: ['./create-blog.component.scss']
})
export class CreateBlogComponent implements OnInit {

  blogImageName: string = '';
  @ViewChild('blogImageInput') blogImageInput: ElementRef;
  blogImageFile : any = null;
  blogTitle: string = '';
  blogContent: string = '';
  midwifeId: any;
  tags = new FormControl([]);
  tagList: Array<IPostTag>;
  imageUrl: any;
  blob: any;
  loading: boolean = false;
  contentType = 'image/png';
  @ViewChild(ImageUploadComponent) blogImgUpload: ImageUploadComponent;
  @ViewChild('selectTag') selectTag: MatSelect;

  constructor(public blogService: BlogService,
    public authService: AuthService,
    private _location: Location,
    private snackBarService: SnackbarService) { }

  ngOnInit(): void {
    this.getTags();
    this.midwifeId = this.authService.getMidwifeId();
  }

  readImage(e :any)
  {
    this.blogImageFile = e.target.files[0];
    this.blogImageName = e.target.files[0].name;
    this.blogImgUpload.fileChangeEvent(e);
    this.blogImgUpload.cropperReady();
    $('#image-upload').modal('show');
  }

  getTags(){
    this.blogService.getBlogPostTags().subscribe((res: IPostTagsResponse)=>{
      this.tagList = res.payload;
      console.log("Tags:", this.tagList);
    },err=>{
      console.error("Tags Error:", err);
    });
  }

  clearFile(){
    this.blogImageName = '';
    this.blogImageInput.nativeElement.value = "";
    this.blogImageFile = null;
  }

  clearData(){
    this.blogTitle = '';
    this.blogContent = '';
    this.blob = null;
    this.tags.reset();
    this.clearFile();
    this._location.back();
  }

  publish(){
    this.loading = true;
    var topicIds: number[] = [];
    var tags:Array<IPostTag> = this.tags.value;
    tags.forEach(res=>topicIds.push(res.topicId));

    const frmData = new FormData();
    frmData.append('image', this.blob, this.blogImageName);
    frmData.append('title', this.blogTitle);
    frmData.append('body', this.blogContent);
    frmData.append('tagIds', String(topicIds));
    frmData.append('midwifeId', this.midwifeId);

    this.blogService.createBlog(frmData)
    .subscribe((res: IBlogResponse)=>{
      console.log("Blog Created:", res.post);
      this.clearData();
      this.loading = false;
    },err=>{
      console.error("Blog Create Error:", err);
      this.snackBarService.openSnackBar(err.error.errorMessage, null, 'top');
      this.loading = false;
    });
  }

  setBlogImage(image: any): void{
    if(image)
    {
      this.blob = base64StringToBlob(String(image).slice(22), this.contentType);
    }
    else{
      this.clearFile();
    }
  }

  closeDropdown(){
    this.selectTag.close();
  }
}
